/* eslint-disable no-unused-vars */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { RootState } from 'src/configs/store';
import RouterRedirect from '../RouterRedirect/RouterRedirect';
import GuardRoute from '../GuardRoute/GuardRoute';
import RetailPage from '../Page/RetailPage';
import Page from 'src/containers/Page/Page';
import RetailHome from 'src/pages/RetailHome/RetailHome';
import SportsBetting from 'src/pages/SportsBetting/SportsBetting';
import LottoLobby from 'src/pages/LottoLobby/LottoLobby';
import LottoDraw from 'src/pages/LottoDraw/LottoDraw';
import NextRaces from 'src/pages/NextRaces/NextRaces';
import RacingDetail from 'src/pages/RacingDetail/RacingDetail';
import Login from 'src/pages/Login/Login';
import OMR from 'src/pages/OMR/OMR';
import Endshift from 'src/pages/RetailFeatures/EndShift/EndShift';

import PrivateRoute from '../PrivateRoute/PrivateRoute';
import RetailReprint from 'src/pages/RetailFeatures/RetailReprint/RetailReprint';
import Ticket from 'src/pages/RetailFeatures/Ticket/Ticket';
import Cards from 'src/pages/RetailFeatures/Cards/Cards';
import RetailTest from 'src/pages/RetailTests/RetailTest';
import Transactions from 'src/pages/RetailFeatures/Transactions/Transactions';
import RegisterBet from 'src/pages/RegisterBet/RegisterBet';
import RetailPasswordChange from 'src/components/Modal/RetailPasswordChange/RetailPasswordChange';
import AdminSession from 'src/pages/RetailFeatures/AdminSession/AdminSession';
import SecondScreen from 'src/pages/SecondScreen/SecondScreen';
import AutoTransactions from 'src/pages/AutoTransactions/AutoTransactions';

export default function RetailRouting() {
  const { tillUser } = useSelector((state: RootState) => state.auth);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get('token');

  return (
    <>
      {
        _.isNull(tillUser)
          ? !token ? (
            <Route render={ () => <Login /> } />
          ) :
            (
              <Route render={ () => <RetailPasswordChange /> } />
            )
          : (
            <Switch>
              { /* HOME */ }
              <Route
                exact
                path="/"
                render={ () => <RetailHome /> }
              />
              <Route
                exact
                path="/test-omr"
                render={ () => <OMR /> }
              />
              <Route
                exact
                path="/end-of-shift"
                render={ () => <Endshift /> }
              />
              <Route
                exact
                path="/cancel-ticket"
                render={ () => <Ticket isCancel /> }
              />
              <Route
                exact
                path="/cancel-ticket-request"
                render={ () => <Ticket isCancelRequest /> }
              />
              <Route
                exact
                path="/get-ticket"
                render={ () => <Ticket isGetTicket /> }
              />
              <Route
                exact
                path="/tests"
                render={ () => <RetailTest /> }
              />
              <Route
                exact
                path="/payout-ticket"
                render={ () => <Ticket isPayout /> }
              />
              <Route
                exact
                path="/reprint"
                render={ () => <RetailReprint /> }
              />
              <Route
                exact
                path="/transactions"
                render={ () => <Transactions /> }
              />
              <Route
                exact
                path="/auto-transactions"
                render={ () => <AutoTransactions /> }
              />
              <Route
                exact
                path="/cards"
                render={ () => <Cards /> }
              />
              <Route
                exact
                path="/register-bet"
                render={ () => <RegisterBet /> }
              />
              <Route
                exact
                path="/session-admin"
                render={ () => <AdminSession /> }
              />

              { /* SPORTS BETTING */ }
              <Route exact path="/sports-betting">
                <RouterRedirect to="/sports-betting/prematch" />
              </Route>
              <Route
                exact
                path="/sports-betting/:type"
                render={ () => <SportsBetting /> }
              />

              { /* LOTTO */ }
              <Route
                exact
                path="/lotto"
                render={ () => <LottoLobby /> }
              />
              <GuardRoute
                path="/lotto/:tournamentCode/:eventId"
                render={ () => <LottoDraw /> }
              />

              { /* RACING */ }
              <Route exact path="/racing">
                <RouterRedirect to="/racing/today" />
              </Route>
              <Route
                exact
                path="/racing/next-races"
                render={ () => <NextRaces /> }
              />
              <Route
                exact
                path="/racing/:type"
                render={ routeProps => <Page { ...routeProps } childComponent="HorseBetting" /> }
              />
              <GuardRoute
                exact
                path={ ['/racing/:meetingCode/:event', '/racing/:meetingCode/:event/:tab', '/racing/:meetingCode/:event/:tab/:market'] }
                render={ () => <RacingDetail /> }
              />

              { /* BET ON GAMES */ }
              <Route
                path="/bet-on-games"
                render={ routeProps => <RetailPage { ...routeProps } childComponent="ComingSoon" /> }
              />

              <Route
                path="/second-screen-menu"
                render={ () => <SecondScreen /> }
              />

              { /* Account */ }
              <PrivateRoute
                exact
                path={ ['/account', '/account/:tab'] }
                render={ routeProps => <RetailPage { ...routeProps } childComponent="AccountHistory" /> }
              />

              <Route path="*">
                <RetailHome />
              </Route>
            </Switch>
          )
      }
    </>
  );
}
